import React from 'react';
import Svg, { G, Mask, Path } from 'react-native-svg';

const UnableToFetch = () => (
  <Svg width="183" height="161" viewBox="0 0 183 161" fill="none">
    <Path
      d="M44.0703 9.32422V17.0629"
      stroke="#AFAFAF"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <Path
      d="M40.2202 13.1953H47.9202"
      stroke="#AFAFAF"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <Path
      d="M64.0698 14.5488C65.0363 14.5488 65.8198 13.7614 65.8198 12.79C65.8198 11.8187 65.0363 11.0312 64.0698 11.0312C63.1033 11.0312 62.3198 11.8187 62.3198 12.79C62.3198 13.7614 63.1033 14.5488 64.0698 14.5488Z"
      fill="#D9D9D9"
    />
    <Path
      d="M74.4058 41.2494C92.1485 48.8896 98.6746 49.9102 115.337 47.6496C140.076 44.2967 165.625 58.9676 158.314 88.4814C152.689 111.18 133.34 132.201 114.499 136.082C82.771 142.618 42.0452 123.549 26.2634 95.2628C12.6565 70.8786 19.7532 43.1778 41.6734 35.1107C49.1079 32.3744 57.412 33.9311 74.4058 41.2494Z"
      fill="#F4F4F4"
    />
    <Path
      d="M146.177 84.4035L74.2069 27.3477C69.317 23.4171 62.1105 24.2292 58.222 29.1748C56.9715 30.7844 56.1021 32.7323 55.8661 34.7323L43.5113 125.74C42.6565 131.984 46.9933 137.735 53.1711 138.627C55.1882 138.921 57.2244 138.655 59.1217 137.891L143.447 103.938C149.244 101.604 152.071 94.9353 149.729 89.1185C148.984 87.2678 147.786 85.6608 146.177 84.4035Z"
      fill="#D9D9D9"
    />
    <Mask
      id="mask0_468_8600"
      style={{maskType: 'luminance'}}
      maskUnits="userSpaceOnUse"
      x="51"
      y="19"
      width="111"
      height="102"
    >
      <Path d="M161.9 19.0312H51.126V120.031H161.9V19.0312Z" fill="white" />
    </Mask>
    <G mask="url(#mask0_468_8600)">
      <Path
        d="M155.512 99.8428L115.267 29.1781C112.55 24.3325 106.363 22.6164 101.533 25.3925C99.9736 26.3011 98.6154 27.6134 97.7602 29.1781L57.5152 99.8428C54.7484 104.688 56.4085 110.846 61.1876 113.622C62.7471 114.531 64.5078 114.985 66.3188 114.985H146.809C152.342 114.985 156.87 110.442 156.87 104.89C156.87 103.124 156.417 101.407 155.512 99.8428Z"
        fill="white"
        stroke="#AFAFAF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M106.563 54.4141L107.122 87.1758"
        stroke="#AFAFAF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M107.781 94.793H107.832"
        stroke="#AFAFAF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M151.312 69.2233H134.947C127.497 69.2233 121.471 63.149 121.471 55.682C121.471 48.1955 127.516 42.1406 134.947 42.1406C140.916 42.1406 146.152 46.0676 147.866 51.813H151.312C156.106 51.813 159.975 55.7013 159.975 60.5181C159.975 65.335 156.106 69.2233 151.312 69.2233Z"
        fill="white"
        stroke="#AFAFAF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </G>
    <Path
      d="M91.2286 71.8119C90.42 69.466 88.2253 67.9022 85.7803 67.9022H81.5255C79.9276 62.194 74.0749 58.8708 68.4533 60.4933C64.5066 61.6271 61.5417 64.9895 60.8872 69.0946"
      fill="white"
    />
    <Path
      d="M91.2286 71.8119C90.42 69.466 88.2253 67.9022 85.7803 67.9022H81.5255C79.9276 62.194 74.0749 58.8708 68.4533 60.4933C64.5066 61.6271 61.5417 64.9895 60.8872 69.0946"
      stroke="#AFAFAF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M82.8922 77.6765C87.686 77.6765 91.5557 81.6058 91.5557 86.4733C91.5557 91.3409 87.686 95.2701 82.8922 95.2701H66.5471C59.0965 95.2701 53.0706 89.1514 53.0513 81.6058C53.0513 74.0405 59.0773 67.9219 66.5086 67.9023C72.4768 67.9023 77.7326 71.8707 79.4268 77.6765H82.873H82.8922Z"
      fill="white"
      stroke="#AFAFAF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M159.169 25.0312V32.77"
      stroke="#AFAFAF"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <Path
      d="M155.32 28.8984H163.02"
      stroke="#AFAFAF"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <Path
      d="M177.169 102.031V109.77"
      stroke="#AFAFAF"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <Path
      d="M173.32 105.898H181.02"
      stroke="#AFAFAF"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <Path
      d="M172.07 128.549C173.036 128.549 173.82 127.761 173.82 126.79C173.82 125.819 173.036 125.031 172.07 125.031C171.103 125.031 170.32 125.819 170.32 126.79C170.32 127.761 171.103 128.549 172.07 128.549Z"
      fill="#D9D9D9"
    />
  </Svg>
);

export default UnableToFetch;